import React from 'react';
import { Card, CssBaseline } from '@mui/material';
import styled from 'styled-components';
import { Navbar } from '../Navbar/Navbar';
import { Footer } from '../Footer';
import { ContactUs } from './section/ContactPage';
import SEO from '../../components/SEO';

const StyledCard = styled.div`
  background-color: #f7f7f7;
  padding: 0px;
 box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
`;

const TopMargin = styled.div`
  margin-top: 100px;
`;

function Contact() {
  return (
    <>
      <SEO
        title="Contact WatchNod | Server & API Monitoring Support"
        description="Contact WatchNod for support, queries, or help with server monitoring and API monitoring. We're here to keep your systems reliable and running."
        url="/contact"
        type="website"
      />
      <Navbar />
      <TopMargin />
      <CssBaseline />
      <StyledCard>
        <Card>
          <ContactUs />
        </Card>
      </StyledCard>
      <div style={{ position: 'relative', bottom: 0, width: '100%' }}>
        <Footer />
      </div>
    </>
  );
}

export default Contact;
